import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
//
export function Message(data, success, fail, returnData) {
  this.data = data
  this.success = function() {
    return success
  }
  this.fail = function() {
    return fail
  }
  if (data.code === 0) {
    Toast.success(data.msg)
    if (this.success()) {
      if (typeof success !== 'function') {
        console.error('Message第一参数需要为方法')
      } else {
        success()
      }
    }
  } else {
    Toast.fail(data.msg)
    if (this.fail()) {
      if (typeof fail !== 'function') {
        console.error('Message第二参数需要为方法')
      } else {
        fail()
      }
    }
  }
  if (returnData) {
    return returnData
  }
}
Vue.prototype.Message = Message
Vue.prototype.Toast = Toast



// WEBPACK FOOTER //
// ./src/utils/Message.js